import { FC, ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAppSelector } from 'src/hooks/useStore';
import { selectAuth } from 'src/features/auth/authSlice';
import { TwoFactorAuthentication } from '../features/auth';

interface GuestGuardProps {
  children: ReactNode;
}

export const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated, is2FA } = useAppSelector(selectAuth);

  useEffect(() => {
    console.log('is2FA ::: ', is2FA);
  }, [is2FA]);

  if (isAuthenticated) {
    return <Navigate to="/dashboard/users/list" />;
  } else if (is2FA) {
    return <TwoFactorAuthentication />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};
